module.exports = __webpack_public_path__ + "img/protection_active.92cd87ca.svg";